export function isElementOrContains(element: HTMLElement | null, target: EventTarget | HTMLElement) {
  if (element && target instanceof Element) {
    return element.contains(target);
  }
  return false;
}
